// src/components/AuthGuard.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminGuard = ({ children }) => {
  // console.log('children: ', children);
  const user = JSON.parse(localStorage.getItem('user-cred'));
  if (!user || !user.token) {
    return <Navigate to="/login" replace />;
  }

  if(user?.user?.user_status !== '1' && user?.user?.user_status !== '2' ){
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminGuard;
